/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';

import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';

const styleMap = {
	xxxxlarge: css({
		font: token('font.heading.xxlarge'),
		fontFamily: token('font.family.brand.heading'),
		fontWeight: token('font.weight.bold'),
		[media.above.md]: {
			// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
			fontSize: '3rem', // custom size
			// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
			lineHeight: '3.5rem',
		},
	}),
	xxxlarge: css({
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		font: token('font.heading.xlarge'),
		fontFamily: token('font.family.brand.heading'),
		[media.above.md]: {
			// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
			fontSize: '2.5rem',
			// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
			lineHeight: '3.5rem',
		},
	}),
};

interface HeroHeadingProps {
	size: 'xxxxlarge' | 'xxxlarge';
	testId?: string;
	children: ReactNode;
}

/**
 * __Hero heading__
 *
 * A hero heading renders a large heading to display at the top of a page.
 *
 */
const HeroHeading = ({ size, testId, children }: HeroHeadingProps) => {
	const headingLevelStyles = styleMap[size];

	return (
		// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/use-heading -- Ignored via go/DSP-18766
		<h1 data-testid={testId} css={headingLevelStyles}>
			{children}
		</h1>
	);
};

export default HeroHeading;
